export const getLayout = () => ({
  sidebar: 260,
  sidebarCollapsed: 56,
  sideBarLarge: 300,
  topBar: 56,
  topBarMedium: 64,
  topBarLarge: 86,
  contentPadding: '1rem',
})
